import moment, { Moment } from 'moment'

import { GetterTree } from 'vuex'

import { OrderPayment } from '@/models'

import { groupByDay, orderByDateField } from '@/utils'

import { RootState } from '../../state'
import { OrderingState } from '../state'

const getters: GetterTree<OrderingState, RootState> = {
  orderPaymentById: (state) => (id: number): OrderPayment | null => {
    return state.orderPayments.elements.find((i) => i.id === id) || null
  },

  orderPaymentByInvoiceId: (state) => (id: number): OrderPayment | null => {
    return state.orderPayments.elements.find((i) => i.ownerId === id) || null
  },

  filteredOrderPayments (state): OrderPayment[] {
    const query = state.orderPayments.query

    const fromDate = query.startDate ? moment.utc(query.startDate).startOf('day') : null
    const untilDate = query.endDate ? moment.utc(query.endDate).endOf('day') : null

    return state.orderPayments.elements.filter((orderPayment) => (
      (!fromDate || fromDate.isSameOrBefore(orderPayment.lastUpdate)) &&
      (!untilDate || untilDate.isSameOrAfter(orderPayment.lastUpdate)) &&
      (!query.status || query.status.length === 0 || query.status.includes(orderPayment.status))
    ))
  },

  orderedOrderPayments (_, getters): OrderPayment[] {
    return orderByDateField(getters.filteredOrderPayments, 'lastUpdate')
  },

  orderPaymentGroupsByDay (_, getters): { day: Moment; groupedOrderPayments: Record<'lastUpdate', Date>[]; isToday: boolean }[] {
    const now = moment()
    const today = now.clone().startOf('day')

    const orderPaymentGroupByDay = groupByDay(getters.orderedOrderPayments, 'lastUpdate')

    const orderPaymentGroups = orderPaymentGroupByDay.map(([day, groupedOrderPayments]) => ({
      day,
      groupedOrderPayments,
      isToday: day.isSame(today)
    }))

    for (const orderPaymentGroup of orderPaymentGroups) {
      if (orderPaymentGroup.isToday) {
        orderPaymentGroup.groupedOrderPayments.reverse()
      }
    }

    return orderPaymentGroups
  }
}

export default getters
